export default "__VITE_ASSET__c0b0e54b__"